import { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import Money from '../../../components/Common/Money/Money';
import ContentApp from '../../../components/ContentApp';
import axios from 'axios';
import { formatDateHours, getLocale } from '../../../helpers/dates';
import { useSelector } from 'react-redux';
import CreditCardList from '../../../components/CreditCard/CreditCardList';
import ButtonProccessing, {
  ButtonStatus,
} from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { WelletContext } from '../../../context/WelletContext';

const ConsumePay = () => {
  const welletContext = useContext(WelletContext);
  const history = useHistory();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentCardId, setCurrentCardId] = useState(null);
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);
  const { total, discount, tip } = history.location.state
    ? history.location.state
    : { total: 0, discount: 0, tip: 0 };

  useEffect(() => {
    if (!history.location.state) history.push('/consume-summary');
  }, []);

  const handleCardIdChange = (id) => {
    setCurrentCardId(id);
  };

  const handleSubmit = async () => {
    setBtnStatus(ButtonStatus.InProgress);

    try {
      const result = await welletContext.apis.tickets.post('/test/CustomerPay', {
        table: '11',
        amount: total,
        discountAmount: discount,
        tipAmount: tip,
        cardId: currentCardId,
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setTimeout(() => {
        history.push('/consume-pay-confirm');
      }, 2000);
    }

    setTimeout(() => {
      setBtnStatus(ButtonStatus.ProgressFinished);
    }, 3000);
  };

  return (
    <>
      <Header title={'Cuenta #6554946'} />
      <ContentApp>
        <div className='text-center mt-4'>
          <div className=''>
            <div
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '30px',
                backgroundColor: '#fff',
                margin: '0 auto',
                lineHeight: '90px',
              }}
            >
              <img
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                }}
                src='https://cdn1.wellet.dev/f50b0f5c-85f9-4f36-b5ad-7f09d7d63286'
              />
            </div>
          </div>
          <div className='fw-bold font-large  mt-4'>Tantra Tulum</div>
          <div className='text-secondary font-smaller'>
            Pago {formatDateHours(new Date(), locale)}
          </div>
        </div>

        <div className='mt-5'>
          <div className='row mt-1'>
            <div className='col text-secondary pr-0'>Tu compra:</div>
            <div className='col-auto'>
              <Money value={total - discount} />
            </div>
          </div>

          {tip > 0 && (
            <div className='row mt-1'>
              <div className='col text-secondary pr-0'>Propina:</div>
              <div className='col-auto'>
                <Money value={tip} />
              </div>
            </div>
          )}

          <div className='row mt-3 mx-0'>
            <div className='col-12' style={{ borderBottom: '1px solid #525252' }}></div>
          </div>
          <div className='row mt-3'>
            <div className='col font-normal pr-0'>Total:</div>
            <div className='col-auto font-large '>
              <Money value={total - discount + tip} />
            </div>
          </div>
        </div>
      </ContentApp>
      <div className='content-botton'>
        <div
          style={{
            backgroundColor: '#1a1a1a',
            borderRadius: '24px 24px 0 0',
            padding: '2rem 15px calc(1rem + env(safe-area-inset-bottom))',
          }}
        >
          <CreditCardList onCardIdChange={(r) => handleCardIdChange(r)} />
          <ButtonProccessing
            status={btnStatus}
            text={
              <>
                Pagar <Money value={total - discount + tip} />
              </>
            }
            size='large'
            className={`mt-5`}
            type='submit'
            onClick={() => handleSubmit()}
            arrow
            color='#000'
            backgroundColor='var(--color-primary)'
            iconColor='#000'
          />
        </div>
      </div>
    </>
  );
};

export default ConsumePay;
